// AppDataContext.tsx
import React, { createContext, useState } from "react";
import { ResponseRequestType } from "./types/service";

interface AppDataContextType {
  identificationResponseList: ResponseRequestType[];
  sailorResponseList: ResponseRequestType[];
  violationResponseList: ResponseRequestType[];

  setIdentificationResponseList: React.Dispatch<React.SetStateAction<ResponseRequestType[]>>;
  setSailorResponseList: React.Dispatch<React.SetStateAction<ResponseRequestType[]>>;
  setViolationResponseList: React.Dispatch<React.SetStateAction<ResponseRequestType[]>>;
}

export const AppDataContext = createContext<AppDataContextType | null>(null);

export const AppDataProvider = ({ children }: any) => {
  const [identificationResponseList, setIdentificationResponseList] = useState<ResponseRequestType[]>(MOCK_DATA_ID);
  const [sailorResponseList, setSailorResponseList] = useState<ResponseRequestType[]>(MOCK_DATA_SAILOR);
  const [violationResponseList, setViolationResponseList] = useState<ResponseRequestType[]>(MOCK_DATA_VIOLATION);

  return (
    <AppDataContext.Provider
      value={{
        identificationResponseList,
        sailorResponseList,
        violationResponseList,
        setIdentificationResponseList,
        setSailorResponseList,
        setViolationResponseList,
      }}
    >
      {children}
    </AppDataContext.Provider>
  );
};

const MOCK_DATA_ID: any[] = [
  {
    transferRequestUid: "0795ca68aaae4294b096aae582fa81e6",
    created: 1763901029067,
    modified: 1763901029068,
    state: 1,
    pathApi: "/hook/sync_key",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "0801beb0f6cc41b7b74059022008e15c",
    applicationSend: {
      uid: "c9ccd304abc04fe2baee01d7aaad2fe6",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "ac33cee09a874ef6b2f1af9808376fef",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-app-id",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 5,
    requestDataFormatUid: "4d0b32f12a074c7aab3ac3a0d24c3368",
    transferResponseData: null,
    uid: "0801beb0f6cc41b7b74059022008e15c",
    applicationSendUid: "c9ccd304abc04fe2baee01d7aaad2fe6",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-11-23T12:30:29.067Z",
    responseAt: "2025-11-23T12:30:29.068Z",
  },
  {
    transferRequestUid: "070b1d10de194601bc5daba0fdbf54ff",
    created: 1763897435777,
    modified: 1763897436468,
    state: 1,
    pathApi: "/hook/sync_key",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "254598a39ab7452999345846afe88041",
    applicationSend: {
      uid: "c9ccd304abc04fe2baee01d7aaad2fe6",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "ac33cee09a874ef6b2f1af9808376fef",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-app-id",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 10,
    requestDataFormatUid: "4d0b32f12a074c7aab3ac3a0d24c3368",
    transferResponseData: null,
    uid: "254598a39ab7452999345846afe88041",
    applicationSendUid: "c9ccd304abc04fe2baee01d7aaad2fe6",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-11-23T11:30:35.777Z",
    responseAt: "2025-11-23T11:30:36.468Z",
  },
  {
    transferRequestUid: "342ccb6c41e043fabfdbad45233fdfc4",
    created: 1763893901048,
    modified: 1763893906213,
    state: 1,
    pathApi: "/hook/sync_key",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "df0c3242fbeb4125b0a8e21437b79602",
    applicationSend: {
      uid: "c9ccd304abc04fe2baee01d7aaad2fe6",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "ac33cee09a874ef6b2f1af9808376fef",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-app-id",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 12,
    requestDataFormatUid: "4d0b32f12a074c7aab3ac3a0d24c3368",
    transferResponseData: null,
    uid: "df0c3242fbeb4125b0a8e21437b79602",
    applicationSendUid: "c9ccd304abc04fe2baee01d7aaad2fe6",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-11-23T10:31:41.048Z",
    responseAt: "2025-11-23T10:31:46.213Z",
  },
  {
    transferRequestUid: "aba0633f712a406f9e882e0bae6f2031",
    created: 1763630794259,
    modified: 1763723900782,
    state: 1,
    pathApi: "/hook/sync_key",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "66475859097642d1928883f8148c2c3f",
    applicationSend: {
      uid: "c9ccd304abc04fe2baee01d7aaad2fe6",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "ac33cee09a874ef6b2f1af9808376fef",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-app-id",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 10,
    requestDataFormatUid: "4d0b32f12a074c7aab3ac3a0d24c3368",
    transferResponseData: null,
    uid: "66475859097642d1928883f8148c2c3f",
    applicationSendUid: "c9ccd304abc04fe2baee01d7aaad2fe6",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-11-20T09:26:34.259Z",
    responseAt: "2025-11-21T11:18:20.782Z",
  },
  {
    transferRequestUid: "b840c4a1d4b3415295c8d0d36169b354",
    created: 1763630789361,
    modified: 1763723900999,
    state: 1,
    pathApi: "/hook/sync_key",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "14bb674c3ca9452291089b833f64b73f",
    applicationSend: {
      uid: "c9ccd304abc04fe2baee01d7aaad2fe6",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "ac33cee09a874ef6b2f1af9808376fef",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-app-id",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 10,
    requestDataFormatUid: "4d0b32f12a074c7aab3ac3a0d24c3368",
    transferResponseData: null,
    uid: "14bb674c3ca9452291089b833f64b73f",
    applicationSendUid: "c9ccd304abc04fe2baee01d7aaad2fe6",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-11-20T09:26:29.361Z",
    responseAt: "2025-11-21T11:18:20.999Z",
  },
  {
    transferRequestUid: "92e92df6edb14e328e69eb635336c2b6",
    created: 1763630784567,
    modified: 1763630784609,
    state: 1,
    pathApi: "/hook/sync_key",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "a761f0d703494487b187544a6d2e15ad",
    applicationSend: {
      uid: "c9ccd304abc04fe2baee01d7aaad2fe6",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "ac33cee09a874ef6b2f1af9808376fef",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-app-id",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 10,
    requestDataFormatUid: "4d0b32f12a074c7aab3ac3a0d24c3368",
    transferResponseData: null,
    uid: "a761f0d703494487b187544a6d2e15ad",
    applicationSendUid: "c9ccd304abc04fe2baee01d7aaad2fe6",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-11-20T09:26:24.567Z",
    responseAt: "2025-11-20T09:26:24.609Z",
  },

  {
    transferRequestUid: "b3f7c1d2a9e34467a1b921c53de18a10",
    created: 1764901129001,
    modified: 1764901129055,
    state: 1,
    pathApi: "/hook/sync_key",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "91fa0d77b6fc4a60995830afbb2fe211",
    applicationSend: {
      uid: "f1a23cd9a9b94c15afdab8b732901bb1",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "c4aa8a91dcdf45e4bdf9099eac22b881",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-app-id",
      ipAddress: "192.168.1.130",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 11,
    requestDataFormatUid: "4d0b32f12a074c7aab3ac3a0d24c3368",
    transferResponseData: null,
    uid: "ff12bb45d0ac4a8ab998310655e7dd10",
    applicationSendUid: "f1a23cd9a9b94c15afdab8b732901bb1",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-12-05T10:11:29.001Z",
    responseAt: "2025-12-05T10:11:29.055Z",
  },
  {
    transferRequestUid: "cd8c4c7e71df4bf3a953bd39cd8abef0",
    created: 1764901155102,
    modified: 1764901155122,
    state: 1,
    pathApi: "/hook/sync_key",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "a8ba9731b6744a0ba3e1c78df4d44012",
    applicationSend: {
      uid: "c912adbb73af42a49fe90f1f267899aa",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-hi",
      host: "https://datalake-api.csb-test.bglobalcorp.vn",
      sourceId: 1,
      created: 1759297982316,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "f71a55b8729747ca8d1122cf94cded01",
      name: "Server khu vực 2",
      deviceId: "INTERNET_DEVICE_data-lake-app-K2",
      ipAddress: "192.168.5.12",
      keyManagementId: null,
      sourceId: 1,
      created: 1759297983182,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 4,
    requestDataFormatUid: "4d0b32f12a074c7aab3ac3a0d24c3368",
    transferResponseData: null,
    uid: "bb8daaeac14e4f21898e2f119ef22331",
    applicationSendUid: "c912adbb73af42a49fe90f1f267899aa",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-12-05T10:12:35.102Z",
    responseAt: "2025-12-05T10:12:35.122Z",
  },
  {
    transferRequestUid: "af91e37bbadf4b4a9d498c6422f3aa99",
    created: 1764901188221,
    modified: 1764901188250,
    state: 1,
    pathApi: "/hook/sync_key",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "507a6f19bd23463198f4cdd2f92c9211",
    applicationSend: {
      uid: "e1c45aa43d7f4e6c8df90dca9dde02cc",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-K3",
      host: "https://datalake-api.csb-prod.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "d2921e52db3e4f009dc8ef77fea11001",
      name: "Server khu vực 3",
      deviceId: "INTERNET_DEVICE_app_K3",
      ipAddress: "192.168.10.88",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 4,
    requestDataFormatUid: "4d0b32f12a074c7aab3ac3a0d24c3368",
    transferResponseData: null,
    uid: "0ed71c004fa84dfa9d0d88efbc0e7322",
    applicationSendUid: "e1c45aa43d7f4e6c8df90dca9dde02cc",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-12-05T10:13:08.221Z",
    responseAt: "2025-12-05T10:13:08.250Z",
  },
  {
    transferRequestUid: "8b9367a87c6d404b8527f79e933f4056",
    created: 1759825645722,
    modified: 1759825645756,
    state: 1,
    pathApi: "/hook/sync_key",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "14bae7cc43df4a6880113b3afaa8f2cc",
    applicationSend: {
      uid: "e6f1be53239e45458dd51ccf066a5dd7",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id-hi",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759297982316,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "df1a74617a164426b0d1214d93ca3d9c",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-apphi",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759297983182,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 12,
    requestDataFormatUid: "4d0b32f12a074c7aab3ac3a0d24c3368",
    transferResponseData: null,
    uid: "14bae7cc43df4a6880113b3afaa8f2cc",
    applicationSendUid: "e6f1be53239e45458dd51ccf066a5dd7",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-10-07T08:27:25.722Z",
    responseAt: "2025-10-07T08:27:25.756Z",
  },
  {
    transferRequestUid: "aa1991971dbf4d5682f54137a4494161",
    created: 1759825343871,
    modified: 1759825343971,
    state: 1,
    pathApi: "/hook/sync_key",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "275bb3bc148441ed941c899ddff706e6",
    applicationSend: {
      uid: "e6f1be53239e45458dd51ccf066a5dd7",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id-hi",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759297982316,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "df1a74617a164426b0d1214d93ca3d9c",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-apphi",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759297983182,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 10,
    requestDataFormatUid: "4d0b32f12a074c7aab3ac3a0d24c3368",
    transferResponseData: null,
    uid: "275bb3bc148441ed941c899ddff706e6",
    applicationSendUid: "e6f1be53239e45458dd51ccf066a5dd7",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-10-07T08:22:23.871Z",
    responseAt: "2025-10-07T08:22:23.971Z",
  },
  {
    transferRequestUid: "89d1c28184154119882bafc8ed117d5f",
    created: 1759824976607,
    modified: 1759824976609,
    state: 1,
    pathApi: "/hook/sync_key",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "b9e0a47fa6834efbb9c0be01e09f20f4",
    applicationSend: {
      uid: "e6f1be53239e45458dd51ccf066a5dd7",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id-hi",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759297982316,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "df1a74617a164426b0d1214d93ca3d9c",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-apphi",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759297983182,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 10,
    requestDataFormatUid: "4d0b32f12a074c7aab3ac3a0d24c3368",
    transferResponseData: null,
    uid: "b9e0a47fa6834efbb9c0be01e09f20f4",
    applicationSendUid: "e6f1be53239e45458dd51ccf066a5dd7",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-10-07T08:16:16.607Z",
    responseAt: "2025-10-07T08:16:16.609Z",
  },
  {
    transferRequestUid: "0dce39931dfc43b6b764d9171da42ce3",
    created: 1759805834435,
    modified: 1759805834550,
    state: 1,
    pathApi: "/hook/sync_key",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "04250d484ca64d07a2d776f08517a45c",
    applicationSend: {
      uid: "e6f1be53239e45458dd51ccf066a5dd7",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id-hi",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759297982316,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "df1a74617a164426b0d1214d93ca3d9c",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-apphi",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759297983182,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 10,
    requestDataFormatUid: "4d0b32f12a074c7aab3ac3a0d24c3368",
    transferResponseData: null,
    uid: "04250d484ca64d07a2d776f08517a45c",
    applicationSendUid: "e6f1be53239e45458dd51ccf066a5dd7",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-10-07T02:57:14.435Z",
    responseAt: "2025-10-07T02:57:14.550Z",
  },
];

const MOCK_DATA_SAILOR: any[] = [
  {
    transferRequestUid: "0a8247e098ac484d9cd419386abb4854",
    created: 1763985477366,
    modified: 1763985478401,
    state: 1,
    pathApi: "/hook/person/list",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "be178cadeed34db5b2c388f6bb3f4c10",
    applicationSend: {
      uid: "c9ccd304abc04fe2baee01d7aaad2fe6",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "ac33cee09a874ef6b2f1af9808376fef",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-app-id",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 10,
    requestDataFormatUid: "7e04a0caac43408da93a829cf7df1732",
    transferResponseData: null,
    uid: "be178cadeed34db5b2c388f6bb3f4c10",
    applicationSendUid: "c9ccd304abc04fe2baee01d7aaad2fe6",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-11-24T11:57:57.366Z",
    responseAt: "2025-11-24T11:57:58.401Z",
  },
  {
    transferRequestUid: "fe2c5ffc26ea442b9327fd1e8ce24755",
    created: 1763626750900,
    modified: 1763723901011,
    state: 1,
    pathApi: "/hook/person/list",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "af56947729ef47d9922fdf4c3723c84a",
    applicationSend: {
      uid: "c9ccd304abc04fe2baee01d7aaad2fe6",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "ac33cee09a874ef6b2f1af9808376fef",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-app-id",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 11,
    requestDataFormatUid: "7e04a0caac43408da93a829cf7df1732",
    transferResponseData: null,
    uid: "af56947729ef47d9922fdf4c3723c84a",
    applicationSendUid: "c9ccd304abc04fe2baee01d7aaad2fe6",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-11-20T08:19:10.900Z",
    responseAt: "2025-11-21T11:18:21.011Z",
  },
  {
    transferRequestUid: "87fa645c5f684a08aa427b91e21fd0c8",
    created: 1761014454475,
    modified: 1761014457162,
    state: 1,
    pathApi: "/hook/person/list",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "156398e32ec14cdd8c504287ae6c061c",
    applicationSend: {
      uid: "e6f1be53239e45458dd51ccf066a5dd7",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id-hi",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759297982316,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "df1a74617a164426b0d1214d93ca3d9c",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-apphi",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759297983182,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 10,
    requestDataFormatUid: "7e04a0caac43408da93a829cf7df1732",
    transferResponseData: null,
    uid: "156398e32ec14cdd8c504287ae6c061c",
    applicationSendUid: "e6f1be53239e45458dd51ccf066a5dd7",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-10-21T02:40:54.475Z",
    responseAt: "2025-10-21T02:40:57.162Z",
  },
  {
    transferRequestUid: "a4d9f8e5458f4434bed4dfa268c30a89",
    created: 1759753235737,
    modified: 1759753235945,
    state: 1,
    pathApi: "/hook/person/list",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "d1fea0c316d94844b13830ef5e8b4926",
    applicationSend: {
      uid: "e6f1be53239e45458dd51ccf066a5dd7",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id-hi",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759297982316,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "df1a74617a164426b0d1214d93ca3d9c",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-apphi",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759297983182,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 5,
    requestDataFormatUid: "7e04a0caac43408da93a829cf7df1732",
    transferResponseData: null,
    uid: "d1fea0c316d94844b13830ef5e8b4926",
    applicationSendUid: "e6f1be53239e45458dd51ccf066a5dd7",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-10-06T12:20:35.737Z",
    responseAt: "2025-10-06T12:20:35.945Z",
  },
  {
    transferRequestUid: "f23ab192aa7a4b748fd73122fe9922aa",
    created: 1764901204411,
    modified: 1764901204420,
    state: 1,
    pathApi: "/hook/sync_key",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "4b92d91521b44cf3938cca812409bba0",
    applicationSend: {
      uid: "c11abf92d3eb436a811909e2344afbb9",
      name: "Cục tác chiến",
      applicationId: "INTERNET_APP_TAC_CHIEN",
      host: "https://ops-api.csb-develop.bglobalcorp.vn",
      sourceId: 2,
      created: 1759300003121,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "a77b92ff2219440a9febbbd9234501ac",
      name: "Server tác chiến",
      deviceId: "INTERNET_DEVICE_TAC_CHIEN",
      ipAddress: "10.10.10.55",
      keyManagementId: null,
      sourceId: 2,
      created: 1759300003150,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 4,
    requestDataFormatUid: "4d0b32f12a074c7aab3ac3a0d24c3368",
    transferResponseData: null,
    uid: "990ac1fe7a3c4dc2a993e582ada11220",
    applicationSendUid: "c11abf92d3eb436a811909e2344afbb9",
    applicationSendName: "Cục tác chiến",
    createdAt: "2025-12-05T10:13:24.411Z",
    responseAt: "2025-12-05T10:13:24.420Z",
  },
  {
    transferRequestUid: "c8ab01928ffd42b290b34110239da9ce",
    created: 1764901229100,
    modified: 1764901229120,
    state: 1,
    pathApi: "/hook/sync_key",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "8f1ddfc9a64a4cc989bb90234cabd201",
    applicationSend: {
      uid: "d201ffab1123448fa92bb0123d1109cb",
      name: "Phòng Tham mưu",
      applicationId: "INTERNET_APP_THAM_MUU",
      host: "https://tham-muu-api.csb.vn",
      sourceId: 3,
      created: 1759305000011,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "a99b0c2277ee4013aa45ff231a1ee120",
      name: "Server tham mưu",
      deviceId: "INTERNET_DEVICE_TM",
      ipAddress: "10.10.20.12",
      keyManagementId: null,
      sourceId: 3,
      created: 1759305000111,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 10,
    requestDataFormatUid: "4d0b32f12a074c7aab3ac3a0d24c3368",
    transferResponseData: null,
    uid: "7a3119ef8e5a4be6b8339c12d9ff5544",
    applicationSendUid: "d201ffab1123448fa92bb0123d1109cb",
    applicationSendName: "Phòng Tham mưu",
    createdAt: "2025-12-05T10:13:49.100Z",
    responseAt: "2025-12-05T10:13:49.120Z",
  },
  {
    transferRequestUid: "ff78de416e954afd805d0ea0757dba89",
    created: 1759726681461,
    modified: 1759726681462,
    state: 1,
    pathApi: "/hook/person/list",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "ac37a170c26d41908d054f8ed7ba912a",
    applicationSend: {
      uid: "e6f1be53239e45458dd51ccf066a5dd7",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id-hi",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759297982316,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "df1a74617a164426b0d1214d93ca3d9c",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-apphi",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759297983182,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 12,
    requestDataFormatUid: "7e04a0caac43408da93a829cf7df1732",
    transferResponseData: null,
    uid: "ac37a170c26d41908d054f8ed7ba912a",
    applicationSendUid: "e6f1be53239e45458dd51ccf066a5dd7",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-10-06T04:58:01.461Z",
    responseAt: "2025-10-06T04:58:01.462Z",
  },
];

const MOCK_DATA_VIOLATION: any[] = [
  {
    transferRequestUid: "1d17cd24491f4b9da4902144111374a7",
    created: 1764002430371,
    modified: 1764003324266,
    state: 1,
    pathApi: "/hook/ship/data",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "9ac4d228a46a4355a2133b073855899f",
    applicationSend: {
      uid: "c9ccd304abc04fe2baee01d7aaad2fe6",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "ac33cee09a874ef6b2f1af9808376fef",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-app-id",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 10,
    requestDataFormatUid: "eff8f10f7aeb43e5afab3502c1b906e7",
    transferResponseData: null,
    uid: "9ac4d228a46a4355a2133b073855899f",
    applicationSendUid: "c9ccd304abc04fe2baee01d7aaad2fe6",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-11-24T16:40:30.371Z",
    responseAt: "2025-11-24T16:55:24.266Z",
  },
  {
    transferRequestUid: "ee104b19a4a143cfa133757d0935b437",
    created: 1763626748667,
    modified: 1763626806658,
    state: 1,
    pathApi: "/hook/ship/data",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "b5d193bcf7f746098b341262b3221b1a",
    applicationSend: {
      uid: "c9ccd304abc04fe2baee01d7aaad2fe6",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "ac33cee09a874ef6b2f1af9808376fef",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-app-id",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 10,
    requestDataFormatUid: "eff8f10f7aeb43e5afab3502c1b906e7",
    transferResponseData: null,
    uid: "b5d193bcf7f746098b341262b3221b1a",
    applicationSendUid: "c9ccd304abc04fe2baee01d7aaad2fe6",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-11-20T08:19:08.667Z",
    responseAt: "2025-11-20T08:20:06.658Z",
  },
  {
    transferRequestUid: "1f681aed889a475994838441a6a95f80",
    created: 1762416048957,
    modified: 1762416048969,
    state: 1,
    pathApi: "/hook/ship/data",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "bdf32d4fb61847968cbdab44ccf5e641",
    applicationSend: {
      uid: "c9ccd304abc04fe2baee01d7aaad2fe6",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "ac33cee09a874ef6b2f1af9808376fef",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-app-id",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 5,
    requestDataFormatUid: "eff8f10f7aeb43e5afab3502c1b906e7",
    transferResponseData: null,
    uid: "bdf32d4fb61847968cbdab44ccf5e641",
    applicationSendUid: "c9ccd304abc04fe2baee01d7aaad2fe6",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-11-06T08:00:48.957Z",
    responseAt: "2025-11-06T08:00:48.969Z",
  },
  {
    transferRequestUid: "02b38a7793934a4a8aa25f31fa244d45",
    created: 1761820229644,
    modified: 1761820268276,
    state: 1,
    pathApi: "/hook/ship/data",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "22969a90b5844853a82e6a46de71521a",
    applicationSend: {
      uid: "c9ccd304abc04fe2baee01d7aaad2fe6",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "ac33cee09a874ef6b2f1af9808376fef",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-app-id",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 10,
    requestDataFormatUid: "eff8f10f7aeb43e5afab3502c1b906e7",
    transferResponseData: null,
    uid: "22969a90b5844853a82e6a46de71521a",
    applicationSendUid: "c9ccd304abc04fe2baee01d7aaad2fe6",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-10-30T10:30:29.644Z",
    responseAt: "2025-10-30T10:31:08.276Z",
  },
  {
    transferRequestUid: "a12fbb28c3fc4c8e9b9c41b27c51e901",
    created: 1763902029067,
    modified: 1763902029069,
    state: 1,
    pathApi: "/hook/sync_key",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "bb12ed90c1aa498a9d1331c9981ae77e",
    applicationSend: {
      uid: "d1cbc304abc04fe2baee01d7aaad3001",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "ab33cee09a874ef6b2f1af9808376001",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-app-id",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 4,
    requestDataFormatUid: "4d0b32f12a074c7aab3ac3a0d24c3368",
    transferResponseData: null,
    uid: "e912ed90c1aa498a9d1331c9981ae77e",
    applicationSendUid: "d1cbc304abc04fe2baee01d7aaad3001",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-11-23T12:40:29.067Z",
    responseAt: "2025-11-23T12:40:29.068Z",
  },

  {
    transferRequestUid: "b66a9123eaae4414b096aae582f11bb2",
    created: 1763903029067,
    modified: 1763903029068,
    state: 1,
    pathApi: "/hook/sync_key",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "c121beb0f6cc41b7b7405902200900aa",
    applicationSend: {
      uid: "c9ccd304abc04fe2baee01d7aaa00002",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "cc44cee09a874ef6b2f1af9808376112",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-app-id",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 4,
    requestDataFormatUid: "4d0b32f12a074c7aab3ac3a0d24c3368",
    transferResponseData: null,
    uid: "f221beb0f6cc41b7b7405902200900aa",
    applicationSendUid: "c9ccd304abc04fe2baee01d7aaa00002",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-11-23T12:50:29.067Z",
    responseAt: "2025-11-23T12:50:29.068Z",
  },

  {
    transferRequestUid: "9397e8b846364b06b4dfba72163497d6",
    created: 1761818546005,
    modified: 1761819846700,
    state: 1,
    pathApi: "/hook/ship/data",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "90c1d47a6c6d4983be3c8d770cf0148a",
    applicationSend: {
      uid: "c9ccd304abc04fe2baee01d7aaad2fe6",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "ac33cee09a874ef6b2f1af9808376fef",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-app-id",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 10,
    requestDataFormatUid: "eff8f10f7aeb43e5afab3502c1b906e7",
    transferResponseData: null,
    uid: "90c1d47a6c6d4983be3c8d770cf0148a",
    applicationSendUid: "c9ccd304abc04fe2baee01d7aaad2fe6",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-10-30T10:02:26.005Z",
    responseAt: "2025-10-30T10:24:06.700Z",
  },
  {
    transferRequestUid: "195de67191ec4dfdb0d914b73bf530b1",
    created: 1761739324545,
    modified: 1761739324570,
    state: 1,
    pathApi: "/hook/ship/data",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "1fac8993ae954abb9f941fc12d4eeeab",
    applicationSend: {
      uid: "c9ccd304abc04fe2baee01d7aaad2fe6",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "ac33cee09a874ef6b2f1af9808376fef",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-app-id",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 5,
    requestDataFormatUid: "eff8f10f7aeb43e5afab3502c1b906e7",
    transferResponseData: null,
    uid: "1fac8993ae954abb9f941fc12d4eeeab",
    applicationSendUid: "c9ccd304abc04fe2baee01d7aaad2fe6",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-10-29T12:02:04.545Z",
    responseAt: "2025-10-29T12:02:04.570Z",
  },
  {
    transferRequestUid: "284229cd4b404f8baecb807e796241f0",
    created: 1761739249966,
    modified: 1761739274355,
    state: 1,
    pathApi: "/hook/ship/data",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "a1f48164ea604ffa986d6a7e753c4912",
    applicationSend: {
      uid: "c9ccd304abc04fe2baee01d7aaad2fe6",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "ac33cee09a874ef6b2f1af9808376fef",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-app-id",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 12,
    requestDataFormatUid: "eff8f10f7aeb43e5afab3502c1b906e7",
    transferResponseData: null,
    uid: "a1f48164ea604ffa986d6a7e753c4912",
    applicationSendUid: "c9ccd304abc04fe2baee01d7aaad2fe6",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-10-29T12:00:49.966Z",
    responseAt: "2025-10-29T12:01:14.355Z",
  },
  {
    transferRequestUid: "5632aef312be4fa68feda64dba90ae36",
    created: 1761040997851,
    modified: 1761040997857,
    state: 1,
    pathApi: "/hook/ship/data",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "59e5422f3cf04d0e8bea4e7d2ba396da",
    applicationSend: {
      uid: "e6f1be53239e45458dd51ccf066a5dd7",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id-hi",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759297982316,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "df1a74617a164426b0d1214d93ca3d9c",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-apphi",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759297983182,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 10,
    requestDataFormatUid: "eff8f10f7aeb43e5afab3502c1b906e7",
    transferResponseData: null,
    uid: "59e5422f3cf04d0e8bea4e7d2ba396da",
    applicationSendUid: "e6f1be53239e45458dd51ccf066a5dd7",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-10-21T10:03:17.851Z",
    responseAt: "2025-10-21T10:03:17.857Z",
  },
  {
    transferRequestUid: "c44ddf68aaae4294b096aae582fa7201",
    created: 1763904029067,
    modified: 1763904029069,
    state: 1,
    pathApi: "/hook/sync_key",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "aa01beb0f6cc41b7b74059022008e199",
    applicationSend: {
      uid: "a1acd304abc04fe2baee01d7aaad9999",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "dc55cee09a874ef6b2f1af9808376444",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-app-id",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 10,
    requestDataFormatUid: "4d0b32f12a074c7aab3ac3a0d24c3368",
    transferResponseData: null,
    uid: "bb11beb0f6cc41b7b74059022008e199",
    applicationSendUid: "a1acd304abc04fe2baee01d7aaad9999",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-11-23T13:00:29.067Z",
    responseAt: "2025-11-23T13:00:29.068Z",
  },
  {
    transferRequestUid: "d55fd168aaae4294b096aae582fa8abc",
    created: 1763905029067,
    modified: 1763905029068,
    state: 1,
    pathApi: "/hook/sync_key",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "cd01beb0f6cc41b7b74059022008e222",
    applicationSend: {
      uid: "e2ccd304abc04fe2baee01d7aaad7777",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "ef66cee09a874ef6b2f1af9808376555",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-app-id",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 10,
    requestDataFormatUid: "4d0b32f12a074c7aab3ac3a0d24c3368",
    transferResponseData: null,
    uid: "de11beb0f6cc41b7b74059022008e222",
    applicationSendUid: "e2ccd304abc04fe2baee01d7aaad7777",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-11-23T13:10:29.067Z",
    responseAt: "2025-11-23T13:10:29.068Z",
  },

  {
    transferRequestUid: "e77cc568aaae4294b096aae582fa66dd",
    created: 1763906029067,
    modified: 1763906029068,
    state: 1,
    pathApi: "/hook/sync_key",
    method: "GET",
    pathVariable: null,
    typeRequest: 0,
    requestId: "ef91beb0f6cc41b7b74059022008e333",
    applicationSend: {
      uid: "f3ccd304abc04fe2baee01d7aaad5555",
      name: "Cảnh sát biển",
      applicationId: "INTERNET_APP_data-lake-app-id",
      host: "https://datalake-api.csb-develop.bglobalcorp.vn",
      sourceId: 1,
      created: 1759376483549,
      modified: null,
      details: null,
    },
    deviceSend: {
      uid: "aa77cee09a874ef6b2f1af9808376777",
      name: "Cảnh sát biển server",
      deviceId: "INTERNET_DEVICE_data-lake-app-id",
      ipAddress: "192.168.1.122",
      keyManagementId: null,
      sourceId: 1,
      created: 1759376483608,
      modified: null,
      details: null,
      email: null,
    },
    applicationReceive: null,
    deviceReceive: null,
    status: 4,
    requestDataFormatUid: "4d0b32f12a074c7aab3ac3a0d24c3368",
    transferResponseData: null,
    uid: "f811beb0f6cc41b7b74059022008e333",
    applicationSendUid: "f3ccd304abc04fe2baee01d7aaad5555",
    applicationSendName: "Cảnh sát biển",
    createdAt: "2025-11-23T13:20:29.067Z",
    responseAt: "2025-11-23T13:20:29.068Z",
  },
];
